import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TVShowCard from "@/components/base/TVShowCard";
import { tvShows, categories } from "@/mocks/data";

const categoryNames: Record<string, string> = {
  xuanyi: "悬疑",
  dongzuo: "动作",
  aiqing: "爱情",
  kehuan: "科幻",
  xiju: "喜剧",
  kongbu: "恐怖",
};

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === slug);
  const filteredShows = tvShows.filter((s) => s.category === slug);

  const categoryLabel = currentCategory?.name || slug || "";

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${categoryLabel}欧美剧 - 红桃影视大全`,
    description: currentCategory?.description || `${categoryLabel}欧美剧分类，高清在线观看`,
    url: `https://www.hongtao-tv.com/category/${slug}`,
    isPartOf: {
      "@type": "WebSite",
      name: "红桃影视大全",
      url: "https://www.hongtao-tv.com",
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-10">
          <div className="mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: `${categoryLabel}欧美剧` },
              ]}
            />

            <div className="mt-6 mb-8">
              <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                {categoryLabel}欧美剧
              </h1>
              <p className="text-foreground-500 text-sm mt-2">
                {currentCategory?.description || `浏览全部${categoryLabel}欧美剧集`}
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/category/xuanyi"
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                  slug === "xuanyi"
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                    slug === cat.slug
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                  <span className="ml-1 text-xs opacity-70">({cat.count})</span>
                </Link>
              ))}
            </div>

            {filteredShows.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop>
                {filteredShows.map((show) => (
                  <TVShowCard key={show.id} show={show} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                  <i className="ri-emotion-sad-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">暂无该分类的剧集</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}